import {
	Advertisement,
	Campaign,
	CampaignAdvertisement,
	LocationGroupCampaignSearch,
	MainLocationAllocation,
	SlotResults,
} from '@horasys/bellplus/common/types';
import { Mode, TablePaginationResult } from 'store/actions/common';
import { CampaignAdvertisementUIState } from 'store/reducers/campaignReducer';

export const GET_CAMPAIGN_ADVERTISEMENTS = 'GET_CAMPAIGN_ADVERTISEMENTS';
export interface GetCampaignAdvertisementsAction {
	type: typeof GET_CAMPAIGN_ADVERTISEMENTS;
	payload: Array<Advertisement>;
}
export const GET_CAMPAIGN_DATA_LIST = 'GET_CAMPAIGN_DATA_LIST';

export interface GetAllCampaignAction {
	type: typeof GET_CAMPAIGN_DATA_LIST;
	payload: TablePaginationResult;
}

export const GET_CAMPAIGN_BY_ID = 'GET_CAMPAIGN_BY_ID';
export interface GetCampaignById {
	type: typeof GET_CAMPAIGN_BY_ID;
	payload: Campaign;
}

export const UPDATE_CAMPAIGN_MODE = 'UPDATE_CAMPAIGN_MODE';
export interface UpdateCampaignModeAction {
	type: typeof UPDATE_CAMPAIGN_MODE;
	payload: Mode;
}

export const RESET_CAMPAIGN_STATE = 'RESET_CAMPAIGN_STATE';
export interface ResetCampaignState {
	type: typeof RESET_CAMPAIGN_STATE;
}

export const UPDATE_CAMPAIGN_FORM = 'UPDATE_CAMPAIGN_FORM';
export interface UpdateCampaignForm {
	type: typeof UPDATE_CAMPAIGN_FORM;
	payload: Partial<Campaign>;
}

export const UPDATE_CAMPAIGN_ADVERTISEMENT_FORM = 'UPDATE_CAMPAIGN_ADVERTISEMENT_FORM';
export interface UpdateCampaignAdvertisementForm {
	type: typeof UPDATE_CAMPAIGN_ADVERTISEMENT_FORM;
	payload: Partial<CampaignAdvertisement>;
}

export const RESET_CAMPAIGN_ADVERTISEMENT_FORM = 'RESET_CAMPAIGN_ADVERTISEMENT_FORM';
export interface ResetCampaignAdvertismenet {
	type: typeof RESET_CAMPAIGN_ADVERTISEMENT_FORM;
}

export const RESET_CAMPAIGN_ADVERTISEMENT_UI_STATE =
	'RESET_CAMPAIGN_ADVERTISEMENT_UI_STATE';
export interface ResetCampaignAdvertismenetUIState {
	type: typeof RESET_CAMPAIGN_ADVERTISEMENT_UI_STATE;
}

export const GET_CITIES = 'GET_CITIES';
export interface GetCitiesAction {
	type: typeof GET_CITIES;
	payload: Array<string>;
}

export const GET_AREAS_BY_CITIES = 'GET_AREAS_BY_CITIES';
export interface GetAreasByCitiesAction {
	type: typeof GET_AREAS_BY_CITIES;
	payload: Array<string>;
}

export const GET_MAIN_LOCATIONS_SEARCH_BY_AREA = 'GET_MAIN_LOCATIONS_SEARCH_BY_AREA';
export interface GetMainLocationSearchByArea {
	type: typeof GET_MAIN_LOCATIONS_SEARCH_BY_AREA;
	payload: Array<MainLocationAllocation>;
}

export const GET_LOCATION_GROUP_SEARCH_BY_CITY = 'GET_LOCATION_GROUP_SEARCH_BY_CITY';
export interface GetLocationGroupByCity {
	type: typeof GET_LOCATION_GROUP_SEARCH_BY_CITY;
	payload: Array<LocationGroupCampaignSearch>;
}

export const GET_MAIN_LOCATION_AUTO_RESULT = 'GET_MAIN_LOCATION_AUTO_RESULT';
export interface GetMainLocationAutoResult {
	type: typeof GET_MAIN_LOCATION_AUTO_RESULT;
	payload: SlotResults;
}

export const UPDATE_CAMPAIGN_AD_UI_STATE = 'UPDATE_CAMPAIGN_AD_UI_STATE';

export interface UpdateCampaignAdUIState {
	type: typeof UPDATE_CAMPAIGN_AD_UI_STATE;
	payload: Partial<CampaignAdvertisementUIState>;
}

export const UPDATE_AUTO_RESULT_UI_STATE = 'UPDATE_AUTO_RESULT_UI_STATE';
export interface UpdateAutoResultUIState {
	type: typeof UPDATE_AUTO_RESULT_UI_STATE;
	payload: boolean;
}

export const CAMPAIGN_MANUAL_ADD_LOCATION = 'CAMPAIGN_MANUAL_ADD_LOCATION';
export const CAMPAIGN_MANUAL_DELETE_LOCATION = 'CAMPAIGN_MANUAL_DELETE_LOCATION';
export const CAMPAIGN_MANUAL_LOCATION_BOOK_SLOT = 'CAMPAIGN_MANUAL_LOCATION_BOOK_SLOT';
export const UPDATE_LOCATION_SELECT_ALL_DEVICES = 'UPDATE_LOCATION_SELECT_ALL_DEVICES';
export const CAMPAIGN_MANUAL_ADD_LOCATION_GROUP = 'CAMPAIGN_MANUAL_ADD_LOCATION_GROUP';
export const UPDATE_LOCATION_GROUP_SELECT_ALL_DEVICES =
	'UPDATE_LOCATION_GROUP_SELECT_ALL_DEVICES';
export const CAMPAIGN_MANUAL_DELETE_LOCATION_GROUP =
	'CAMPAIGN_MANUAL_DELETE_LOCATION_GROUP';
export const CAMPAIGN_MANUAL_LOCATION_GROUP_BOOK_SLOT =
	'CAMPAING_MANUAL_LOCATION_GROUP_BOOK_SLOT';
export interface CampaignManualAddLocation {
	type: typeof CAMPAIGN_MANUAL_ADD_LOCATION;
	payload: MainLocationAllocation;
}

export interface CampaignManualDeleteLocation {
	type: typeof CAMPAIGN_MANUAL_DELETE_LOCATION;
	payload: MainLocationAllocation;
}

export interface CampaignManualLocationBookSlot {
	type: typeof CAMPAIGN_MANUAL_LOCATION_BOOK_SLOT;
}

export interface UpdateLocationSelectAllDevicesAction {
	type: typeof UPDATE_LOCATION_SELECT_ALL_DEVICES;
	payload: MainLocationAllocation;
}

export interface UpdateLocationGroupSelectAllDevicesAction {
	type: typeof UPDATE_LOCATION_GROUP_SELECT_ALL_DEVICES;
	payload: LocationGroupCampaignSearch;
}

export interface CampaignManualAddLocationGroup {
	type: typeof CAMPAIGN_MANUAL_ADD_LOCATION_GROUP;
	payload: LocationGroupCampaignSearch;
}

export interface CampaignManualDeleteLocationGroup {
	type: typeof CAMPAIGN_MANUAL_DELETE_LOCATION_GROUP;
	payload: LocationGroupCampaignSearch;
}

export interface CampaignManualLocationGrouoBookSlot {
	type: typeof CAMPAIGN_MANUAL_LOCATION_GROUP_BOOK_SLOT;
}

export const UPDATE_MANUAL_RESULT_UI_STATE = 'UPDATE_MANUAL_RESULT_UI_STATE';
export interface UpdateManualResultUIState {
	type: typeof UPDATE_MANUAL_RESULT_UI_STATE;
	payload: boolean;
}

export interface ManualLocationNoOfTimes {
	location: MainLocationAllocation;
	noOfTimes: number;
}

export interface ManualLocationSelectedDevices {
	location: MainLocationAllocation;
	selectedDevices: number;
}

export interface ManualLocationGroupNoOfTimes {
	locationGroup: LocationGroupCampaignSearch;
	noOfTimes: number;
}

export interface ManualLocationGroupSelectedDevices {
	locationGroup: LocationGroupCampaignSearch;
	selectedDevices: number;
}

export const UPDATE_LOCATION_MANUAL_NO_TIMES = 'UPDATE_LOCATION_MANUAL_NO_TIMES';
export const UPDATE_LOCATION_MANUAL_SELECTED_DEVICES =
	'UPDATE_LOCATION_MANUAL_SELECTED_DEVICES';

export const UPDATE_LOCATION_GROUP_MANUAL_NO_TIMES =
	'UPDATE_LOCATION_GROUP_MANUAL_NO_TIMES';
export const UPDATE_LOCATION_GROUP_MANUAL_SELECTED_DEVICES =
	'UPDATE_LOCATION_GROUP_MANUAL_SELECTED_DEVICES';
export interface UpdateLocationManualNoTimes {
	type: typeof UPDATE_LOCATION_MANUAL_NO_TIMES;
	payload: ManualLocationNoOfTimes;
}

export interface UpdateLocationManualSelectedDevices {
	type: typeof UPDATE_LOCATION_MANUAL_SELECTED_DEVICES;
	payload: ManualLocationSelectedDevices;
}

export interface UpdateLocationGroupManualNoTimes {
	type: typeof UPDATE_LOCATION_GROUP_MANUAL_NO_TIMES;
	payload: ManualLocationGroupNoOfTimes;
}

export interface UpdateLocationManualGroupSelectedDevices {
	type: typeof UPDATE_LOCATION_GROUP_MANUAL_SELECTED_DEVICES;
	payload: ManualLocationGroupSelectedDevices;
}

export const GET_MAIN_LOCATION_MANUAL_RESULT = 'GET_MAIN_LOCATION_MANUAL_RESULT';
export interface GetMainLocationManualResult {
	type: typeof GET_MAIN_LOCATION_MANUAL_RESULT;
	payload: SlotResults;
}

export const GET_LOCATION_GROUP_MANUAL_RESULT = 'GET_LOCATION_GROUP_MANUAL_RESULT';
export interface GetLocationGroupManualResult {
	type: typeof GET_LOCATION_GROUP_MANUAL_RESULT;
	payload: SlotResults;
}

export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const DELETE_BOOKED_SLOTS = 'DELETE_BOOKED_SLOTS';

export const CREATE_CAMPAIGN_ADVERTISEMENT = 'CREATE_CAMPAIGN_ADVERTISEMENT';
export const ADD_CAMPAIGN_ADVERTISEMENT = 'ADD_CAMPAIGN_ADVERTISEMENT';
export const DELETE_CAMPAIGN_ADVERTISEMENT = 'DELETE_CAMPAIGN_ADVERTISEMENT';
export const VIEW_CAMPAIGN_ADVERTISEMENT = 'VIEW_CAMPAIGN_ADVERTISEMENT';
export const EDIT_CAMPAIGN_ADVERTISEMENT = 'EDIT_CAMPAIGN_ADVERTISEMENT';

export const CLOSE_CHOOSE_DEVICES_POPUP = 'CLOSE_CHOOSE_DEVICES_POPUP';

export interface CloseChooseDevicesPopup {
	type: typeof CLOSE_CHOOSE_DEVICES_POPUP;
}

export interface DeleteCampaignAdvertisementAction {
	type: typeof DELETE_CAMPAIGN_ADVERTISEMENT;
	payload: number;
}
export interface AddCampaignAdvertisementAction {
	type: typeof ADD_CAMPAIGN_ADVERTISEMENT;
}

export type CampaignAction =
	| GetAllCampaignAction
	| UpdateCampaignModeAction
	| GetAreasByCitiesAction
	| GetCitiesAction
	| GetLocationGroupByCity
	| GetMainLocationSearchByArea
	| GetMainLocationAutoResult
	| GetMainLocationManualResult
	| GetLocationGroupManualResult
	| UpdateCampaignForm
	| ResetCampaignAdvertismenet
	| ResetCampaignAdvertismenetUIState
	| UpdateAutoResultUIState
	| UpdateManualResultUIState
	| UpdateCampaignAdUIState
	| UpdateCampaignModeAction
	| CampaignManualAddLocation
	| GetCampaignAdvertisementsAction
	| CampaignManualDeleteLocation
	| CampaignManualLocationBookSlot
	| ResetCampaignState
	| CampaignManualAddLocationGroup
	| CampaignManualDeleteLocationGroup
	| CampaignManualLocationGrouoBookSlot
	| UpdateLocationManualNoTimes
	| UpdateLocationManualSelectedDevices
	| UpdateLocationGroupManualNoTimes
	| UpdateLocationManualGroupSelectedDevices
	| AddCampaignAdvertisementAction
	| DeleteCampaignAdvertisementAction
	| CloseChooseDevicesPopup
	| GetCampaignById
	| UpdateCampaignAdvertisementForm
	| UpdateLocationSelectAllDevicesAction
	| UpdateLocationGroupSelectAllDevicesAction;
